import sisDkpClienteRouter from './sis-dkp-cliente.router';
import sisDkpClienteTokensRouter from './sis-dkp-cliente-tokens.router';

export default [
  ...sisDkpClienteRouter,
  ...sisDkpClienteTokensRouter,
];
